import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const progressVillageConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Progress Village Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Progress Village, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_progress_village',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Progress Village',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Progress Village Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring professional tree care to the 
     neighborhoods of <strong>Progress Village</strong>. This Southeast Tampa 
     community has established residential streets with mature trees that require 
     ongoing management to stay safe. Overgrown canopies near homes, storm damaged 
     limbs, and trees that have outgrown tight residential lots are all situations 
     our experienced team handles with skill and care.`,

    `We specialize in <strong>dangerous tree removal and targeted trimming</strong> 
     large limbs overhanging homes and fences, trees weakened by storm damage or 
     disease, and precision removals on tight lots in densely developed 
     neighborhoods. We work safely, work efficiently, and leave your 
     property clean after every job.`,

    `<strong>Sam's Tree Service</strong> provides trusted, affordable tree care 
     throughout <strong>Progress Village</strong> and the surrounding 
     <strong>Southeast Tampa</strong> area protecting your property and 
     keeping your trees healthy through every season.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Progress Village, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_ProgressVillage = () => <LocationPage config={progressVillageConfig} />;
export default Services_ProgressVillage;
